<template>
  <div>
    <Header />
    <div class="params-table">
      <img
        class="params-table-logo"
        src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210617160821669-logo_007@2x.png"
      />
      <div class="params-table-desc h3">2020 款 · 详细配置表</div>
      <div ref="navHolder" class="params-table-nav-outer">
        <div ref="nav" class="params-table-nav">
          <div ref="scrollNav" class="params-table-nav-main">
            <div
              class="params-table-nav-main-item h4"
              v-for="(item, index) in nav"
              :class="{ active: index === activeIndex }"
              :key="index"
              @click="changeNav(index, item)"
            >
              {{ item.label }}
            </div>
          </div>
          <img
            class="params-table-nav-img pc"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101409983-web_header@2x.png"
          />
          <img
            class="params-table-nav-img pad"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722452-pad_header@2x.png"
          />
          <img
            class="params-table-nav-img mb"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102008026-phone_header@2x.png"
          />
        </div>
      </div>
      <div class="params-table-images pc">
        <img
          class="params-table-image image-1"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101413081-web_pic_01@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-2"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410396-web_pic_02@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-3"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101413466-web_pic_03@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-4"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410420-web_pic_04@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-5"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410379-web_pic_05@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-6"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410542-web_pic_06@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-7"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410976-web_pic_07@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-8"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101411061-web_pic_08@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-9"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101410988-web_pic_09@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-10"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101411014-web_pic_10@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-11"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101411130-web_pic_11@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-12"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101411168-web_pic_12@2x.png"
          alt=""
        />
        <img
          class="params-table-image-floor image-13"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101414299-web_pic_13@2x.png"
          alt=""
        />
      </div>
      <div class="params-table-images pad">
        <img
          class="params-table-image image-1"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722461-pad_pic_01@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-2"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722856-pad_pic_02@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-3"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101725918-pad_pic_03@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-4"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722884-pad_pic_04@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-5"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722857-pad_pic_05@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-6"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101722697-pad_pic_06@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-7"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101726009-pad_pic_07@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-8"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723012-pad_pic_08@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-9"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723024-pad_pic_09@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-10"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723034-pad_pic_10@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-11"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723137-pad_pic_11@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-12"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723153-pad_pic_12@2x.png"
          alt=""
        />
        <img
          class="params-table-image-floor image-13"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630101723157-pad_pic_13@2x.png"
          alt=""
        />
      </div>
      <div class="params-table-images mb">
        <img
          class="params-table-image image-1"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005133-phone_pic_01@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-2"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005410-phone_pic_02@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-3"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005424-phone_pic_03@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-4"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005555-phone_pic_04@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-5"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005436-phone_pic_05@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-6"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005421-phone_pic_06@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-7"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005646-phone_pic_07@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-8"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005842-phone_pic_08@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-9"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102008796-phone_pic_09@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-10"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005949-phone_pic_10@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-11"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102005986-phone_pic_11@2x.png"
          alt=""
        />
        <img
          class="params-table-image image-12"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630102006064-phone_pic_12@2x.png"
          alt=""
        />
      </div>
    </div>
    <hr class="hr" />
    <Floor />
  </div>
</template>

<script>
import Header from "@components/Header/index.vue";
import Floor from "@components/Floor/index.vue";
import utils from "@utils";
export default {
  name: "params-table-2020",
  components: {
    Header,
    Floor,
  },
  data() {
    this.evenFunc = null;
    this.tops = null;
    this.nowTop = null;
    this.navs = null;
    return {
      activeIndex: 0,
      nav: [
        {
          label: "基本参数",
        },
        {
          label: "动力系统",
        },
        {
          label: "轮毂及底盘",
        },
        {
          label: "安全配置",
        },
        {
          label: "智能驾驶辅助",
        },
        {
          label: "灯光及后视镜",
        },
        {
          label: "智能操作及车载应用",
        },
        {
          label: "内饰系统",
        },
        {
          label: "空调及座椅",
        },
        {
          label: "车窗及外饰",
        },
        {
          label: "出行体验",
        },
        {
          label: "个性化选装",
        }
      ],
    };
  },
  mounted() {
    utils.onImgLoaded(() => {
      this.initEvent();
    })
  },
  unMounted() {
    this.removeEvent();
  },
  methods: {
    initScrollTops() {
      let { nav } = this.$refs;
      let headerEl = document.querySelector(`.header-placeholder`);
      this.navs = [...document.querySelectorAll(`.params-table-nav-main-item`)];
      this.tops = [...document.querySelectorAll(`.params-table-image`)]
        .filter((v) => v.offsetTop)
        .map((v) => v.offsetTop - headerEl.clientHeight - nav.clientHeight);
      let sel = document.scrollingElement || document.documentElement;
      let nowScrollTop = sel.scrollTop;
      this.activeIndex = this.tops.findIndex((v) => v > nowScrollTop) - 1;
      this.nowTop = this.tops[this.activeIndex];
      this.preIndex = Math.max(this.activeIndex - 1,  0);
      this.preTop = this.tops[this.preIndex];
      this.nextIndex = this.activeIndex + 1;
      this.nextTop = this.tops[this.nextIndex];
    },
    checkNavActive(scrollTop) {
      if (this.nextTop && scrollTop >= this.nextTop) {
        !this.lockCheck && (this.activeIndex = this.nextIndex);
        this.preTop = this.nextTop;
        this.preIndex = this.nextIndex;
        this.nextTop = this.tops[++this.nextIndex];
        this.navScroll(this.activeIndex);
      } else if (this.preTop && scrollTop <= this.preTop) {
        !this.lockCheck && (this.activeIndex = this.preIndex);
        this.nextTop = this.preTop;
        this.nextIndex = this.preIndex;
        this.preTop = this.tops[--this.preIndex];
        this.navScroll(this.activeIndex);
      }
      
    },
    checkNavFixed(navHolder, nav, headerEl, scrollTop) {
      let navTop = navHolder.offsetTop - headerEl.clientHeight;
      if (scrollTop >= navTop) {
        navHolder.style.height = nav.clientHeight + "px";
        nav.classList.add("fixed");
      } else {
        navHolder.style.height = "";
        nav.classList.remove("fixed");
      }
    },
    initEvent() {
      this.initScrollTops();
      let { navHolder, nav } = this.$refs;
      let headerEl = document.querySelector(`.header-placeholder`);
      let scrollEl = document.scrollingElement || document.documentElement;
      this.scrollFunc = (ev) => {
        let el = ev.target.scrollingElement;
        let scrollTop = el.scrollTop;
        this.checkNavFixed(navHolder, nav, headerEl, scrollTop);
        this.checkNavActive(scrollTop);
      };
      this.resetFunc = () => {
        this.initScrollTops();
      }
      window.addEventListener("scroll", this.scrollFunc, false);
      window.addEventListener("resize", this.resetFunc, false);
      this.checkNavFixed(navHolder, nav, headerEl, scrollEl.scrollTop);
      this.checkNavActive(scrollEl.scrollTop);
      this.navScroll(this.activeIndex, true);
    },
    removeEvent() {
      window.removeEventListener("scroll", this.evenFunc);
      window.removeEventListener("resize", this.resetFunc);
    },
    changeNav(index) {
      this.activeIndex = index;
      let { nav } = this.$refs;
      let els = document.querySelectorAll(`.image-${index + 1}`);
      let el = [...els].filter((v) => v.offsetTop)[0];
      let headerEl = document.querySelector(`.header-placeholder`);
      let offsetTop = el.offsetTop;
      if (el.offsetTop > nav.offsetTop) {
        offsetTop -= nav.clientHeight;
      }
      this.animateScroll(offsetTop - headerEl.clientHeight);
    },
    navScroll(index, noAni) {
      let item = this.navs[index];
      let el = this.$refs.scrollNav;
      let nowLeft = el.scrollLeft;
      let left = item.offsetLeft;
      if (noAni) {
        return el.scrollTo(left, 0);
      }
      let moveL = left - nowLeft;
      let duration = 260;
      if (moveL === 0) return;
      let startTime = +new Date();
      let run = () => {
        let time = +new Date() - startTime;
        let nextLeft = nowLeft + moveL * (time / duration);
        el.scrollTo(nextLeft, 0);
        run.timer = requestAnimationFrame(run);
        if (time >= duration) {
          el.scrollTo(left, 0);
          cancelAnimationFrame(run.timer);
        }
      }
      run();
    },
    animateScroll(top) {
      let scroller = document.scrollingElement || document.documentElement;
      let pageY = scroller.scrollTop;
      let mY = top - pageY;
      let startTime = +new Date();
      let duration = 450; //ms
      let run = () => {
        let time = +new Date() - startTime;
        let nextTop = pageY + mY * (time / duration);
        scroller.scrollTo(0, nextTop);
        run.timer = requestAnimationFrame(run);
        if (time >= duration) {
          scroller.scrollTo(0, top);
          cancelAnimationFrame(run.timer);
          this.lockCheck = false;
        }
      }
      this.lockCheck = true;
      requestAnimationFrame(run);
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.params-table {
  overflow: hidden;
  margin: 0 auto;
  width: $md;
  @include media(
    (
      $md: (
        width: auto,
      ),
    )
  );
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .params-table-logo {
    margin: 80px auto 24px;
    width: 306px;
    height: 56px;
    display: block;
  }
  .params-table-desc {
    text-align: center;
  }
  .params-table-nav-outer {
    margin-top: 40px;
    .params-table-nav {
      &.fixed {
        position: fixed;
        top: 48px;
        width: $md;
        left: 50%;
        transform: translateX(-50%);

        @include media(
          (
            $md: (
              width: auto,
              transform: translateX(0),
              left: 0,
              right: 0,
            ),
          )
        );
      }
      @include setThemeClass {
        .params-table-nav-main {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          background-color: getThemeVal(lineColor);
          @include media(
            (
              $md: (
                flex-wrap: nowrap,
                overflow-x: auto,
              ),
            )
          );
          .params-table-nav-main-item {
            flex-shrink: 0;
            cursor: pointer;
            flex: 1;
            min-width: 16.66%;
            height: 60px;
            text-align: center;
            line-height: 60px;
            transition: font-size 260ms $easeOutCubic,
              font-weight 260ms $easeOutCubic;
            @include media(
              (
                $md: (
                  min-width: 120px,
                  height: 40px,
                  line-height: 40px,
                ),
              )
            );
            &.active {
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
      }
      .params-table-nav-img {
        width: 100%;
        height: auto;
      }
    }
  }
  .params-table-images {
    .params-table-image,.params-table-image-floor {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
</style>
